import { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./style.css";
import { CloudDownload } from "react-bootstrap-icons";


type OutputDatePickerProps = {
    selectedMonth: Date
    onChange: (param: Date | null) => any
    onClickDownload: (event: React.MouseEvent) => any
    className: string | undefined
    buttonDisabled?: boolean
}

const OutputDatePicker = (props:OutputDatePickerProps) => {
    const renderMonthContent = (month:number, shortMonth:string, longMonth:string, day:Date) => {
        return <span>{shortMonth}</span>;
    };
    return (
        <Container className={props.className} style={{width: "fit-content"}}>
            <Row className="output-datepicker-wrapper justify-content-center">
                <Col className="mt-2">
                    <DatePicker
                        showIcon
                        selected={props.selectedMonth}
                        onChange={props.onChange}
                        renderMonthContent={renderMonthContent}
                        showMonthYearPicker
                        dateFormat="yyyy/MM"
                        disabled={props.buttonDisabled}
                    />
                </Col>
                <Col className="mt-2">
                    <Button variant="primary"
                        style={{ whiteSpace: 'nowrap' }}
                        onClick={(event) => props.onClickDownload(event)}
                        disabled={props.buttonDisabled}
                    >
                        <CloudDownload />{' '}
                        レポートダウンロード
                    </Button>
                </Col>
            </Row>
        </Container>
    );
}

export default OutputDatePicker;